const marked = require("marked");

module.exports.map = async (collection, callback) => {
  const processedCollection = [];

  for(let i=0; i < collection.length; i++) {
    const item = collection[i];
    const processedItem = await callback(item);
    processedCollection.push(processedItem);
  }

  return processedCollection;
};

module.exports.getAsset = (asset) => {
  return {
    name: asset.fields.title,
    url: asset.fields.file.url
  };
};

module.exports.parseMarkdown = (text) => {
    return marked(text);
}

module.exports.formatDate = (timestamp) => {
    const date = new Date(timestamp);
    var months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October',	'November', 'December'];
    return `${date.getDate()} ${months[date.getMonth()]}, ${date.getFullYear()}`;
};
